<template>
  <div class="health-management">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link" style="color: #3498db;">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 页面标题 -->
    <section class="page-header">
      <div class="container">
        <h1>健康管理服务</h1>
        <p>基于量子健康技术的个性化健康管理方案，守护您的身心健康</p>
      </div>
    </section>

    <!-- 服务概览 -->
    <section class="service-overview">
      <div class="container">
        <div class="overview-content">
          <div class="overview-text">
            <h2>全方位健康管理</h2>
            <p>我们结合传统医学智慧与现代量子健康技术，为您提供全方位、个性化的健康管理服务。通过精准的量子检测、科学的评估体系和专业的调理方案，帮助您建立健康的生活方式，预防疾病，提升生活质量。</p>
            <div class="overview-features">
              <div class="feature-item">
                <span class="feature-icon">🎯</span>
                <span>个性化定制</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">🔬</span>
                <span>科学检测</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">📊</span>
                <span>全程跟踪</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">👥</span>
                <span>专家团队</span>
              </div>
            </div>
          </div>
          <div class="overview-image">
            <img src="img/health-management.jpg" alt="全方位健康管理" />
          </div>
        </div>
      </div>
    </section>

    <!-- 服务项目 -->
    <section class="service-items">
      <div class="container">
        <h2>核心服务项目</h2>
        <div class="services-grid">
          <div v-for="service in services" :key="service.id" class="service-card">
            <div class="service-icon">{{ service.icon }}</div>
            <h3>{{ service.title }}</h3>
            <p>{{ service.description }}</p>
            <ul class="service-features">
              <li v-for="feature in service.features" :key="feature">{{ feature }}</li>
            </ul>
            <button @click="showServiceDetail(service)" class="btn-detail">了解详情</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务流程 -->
    <section class="service-process">
      <div class="container">
        <h2>健康管理流程</h2>
        <div class="process-timeline">
          <div v-for="(step, index) in processSteps" :key="step.id" class="process-step">
            <div class="step-number">{{ index + 1 }}</div>
            <div class="step-content">
              <h3>{{ step.title }}</h3>
              <p>{{ step.description }}</p>
              <div class="step-details">
                <span class="step-duration">{{ step.duration }}</span>
                <span class="step-method">{{ step.method }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 适用人群 -->
    <section class="target-audience">
      <div class="container">
        <h2>适用人群</h2>
        <div class="audience-grid">
          <div v-for="audience in targetAudience" :key="audience.id" class="audience-card">
            <div class="audience-icon">{{ audience.icon }}</div>
            <h3>{{ audience.title }}</h3>
            <p>{{ audience.description }}</p>
            <div class="audience-symptoms">
              <span v-for="symptom in audience.symptoms" :key="symptom" class="symptom-tag">
                {{ symptom }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术优势 -->
    <section class="tech-advantages">
      <div class="container">
        <h2>技术优势</h2>
        <div class="advantages-content">
          <div class="advantages-list">
            <div v-for="advantage in techAdvantages" :key="advantage.id" class="advantage-item">
              <div class="advantage-icon">{{ advantage.icon }}</div>
              <div class="advantage-content">
                <h3>{{ advantage.title }}</h3>
                <p>{{ advantage.description }}</p>
              </div>
            </div>
          </div>
          <div class="advantages-image">
            <div class="image-placeholder">⚡</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 成功案例 -->
    <section class="success-cases">
      <div class="container">
        <h2>成功案例</h2>
        <div class="cases-slider">
          <div v-for="caseItem in successCases" :key="caseItem.id" class="case-item">
            <div class="case-header">
              <div class="case-avatar">{{ caseItem.avatar }}</div>
              <div class="case-info">
                <h4>{{ caseItem.name }}</h4>
                <p>{{ caseItem.title }}</p>
              </div>
            </div>
            <div class="case-content">
              <p>{{ caseItem.content }}</p>
              <div class="case-results">
                <div v-for="result in caseItem.results" :key="result.label" class="result-item">
                  <span class="result-label">{{ result.label }}:</span>
                  <span class="result-value">{{ result.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务套餐 -->
    <section class="service-packages">
      <div class="container">
        <h2>服务套餐</h2>
        <div class="packages-grid">
          <div v-for="pkg in packages" :key="pkg.id" class="package-card" :class="{ featured: pkg.featured }">
            <div class="package-header">
              <h3>{{ pkg.name }}</h3>
              <div class="package-price">
                <span class="price">¥{{ pkg.price }}</span>
                <span class="period">{{ pkg.period }}</span>
              </div>
            </div>
            <div class="package-content">
              <p class="package-description">{{ pkg.description }}</p>
              <ul class="package-features">
                <li v-for="feature in pkg.features" :key="feature.text" :class="{ included: feature.included }">
                  <span class="check-icon">{{ feature.included ? '✓' : '✗' }}</span>
                  {{ feature.text }}
                </li>
              </ul>
              <button @click="selectPackage(pkg)" class="btn-select" :class="{ featured: pkg.featured }">
                {{ pkg.featured ? '推荐选择' : '选择套餐' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 预约表单 -->
    <section class="booking-section">
      <div class="container">
        <div class="booking-content">
          <div class="booking-info">
            <h2>开始您的健康管理之旅</h2>
            <p>专业团队为您提供个性化的健康管理方案，让健康成为一种生活方式。立即预约咨询，开启健康新生活。</p>
            <div class="booking-features">
              <div class="booking-feature">
                <span class="icon">👨‍⚕️</span>
                <span>专家一对一咨询</span>
              </div>
              <div class="booking-feature">
                <span class="icon">🔬</span>
                <span>免费健康评估</span>
              </div>
              <div class="booking-feature">
                <span class="icon">📋</span>
                <span>个性化方案定制</span>
              </div>
            </div>
          </div>
          <div class="booking-form">
            <h3>预约咨询</h3>
            <form @submit.prevent="submitBooking">
              <div class="form-group">
                <label>姓名</label>
                <input type="text" v-model="bookingForm.name" placeholder="请输入您的姓名" required>
              </div>
              <div class="form-group">
                <label>电话</label>
                <input type="tel" v-model="bookingForm.phone" placeholder="请输入您的电话" required>
              </div>
              <div class="form-group">
                <label>邮箱</label>
                <input type="email" v-model="bookingForm.email" placeholder="请输入您的邮箱">
              </div>
              <div class="form-group">
                <label>感兴趣的服务</label>
                <select v-model="bookingForm.service">
                  <option value="">请选择服务</option>
                  <option v-for="service in services" :key="service.id" :value="service.title">
                    {{ service.title }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>健康问题描述</label>
                <textarea 
                  v-model="bookingForm.message" 
                  placeholder="请简要描述您的健康需求..." 
                  rows="4"
                ></textarea>
              </div>
              <button type="submit" class="btn-submit">立即预约</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- 常见问题 -->
    <section class="faq-section">
      <div class="container">
        <h2>常见问题</h2>
        <div class="faq-list">
          <div v-for="faq in faqs" :key="faq.id" class="faq-item" @click="toggleFaq(faq)">
            <div class="faq-question">
              <h3>{{ faq.question }}</h3>
              <span class="faq-toggle">{{ faq.open ? '−' : '+' }}</span>
            </div>
            <div v-show="faq.open" class="faq-answer">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p><i class="el-icon-location"></i> 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p><i class="el-icon-phone"></i> 电话：15383753755</p>
              <p><i class="el-icon-message"></i> 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="#home">首页</a>
              <a href="#about">关于我们</a>
              <a href="#services">服务介绍</a>
              <a href="#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关注我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="el-icon-chat-line-square"></i> 微信公众号</a>
                <a href="#" class="social-icon"><i class="el-icon-message-solid"></i> 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p style="font-size: 12px;" @click=" window.open('https://beian.miit.gov.cn/', '_blank', 'noopener noreferrer');">© 2025 北京和合网链科技发展有限公司 版权所有 | 冀ICP备14010297号 | 冀ICP备14010297号-2 | 域名：tssen.com</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HealthManagement',
  data() {
    return {
      services: [
        {
          id: 1,
          title: '量子健康检测',
          icon: '🔬',
          description: '运用先进的量子检测技术，全面评估身体健康状况，为个性化健康管理提供科学依据。',
          features: [
            '全身健康扫描',
            '细胞能量检测',
            '器官功能评估',
            '健康风险预测'
          ]
        },
        {
          id: 2,
          title: '个性化营养指导',
          icon: '🥗',
          description: '根据检测结果和个人体质，制定科学的营养方案，优化身体营养状态。',
          features: [
            '营养需求分析',
            '个性化食谱制定',
            '营养补充指导',
            '饮食跟踪调整'
          ]
        },
        {
          id: 3,
          title: '运动健康管理',
          icon: '🏃‍♂️',
          description: '结合身体状况和健康目标，制定科学的运动计划，提升身体素质。',
          features: [
            '体能评估测试',
            '运动方案定制',
            '运动指导监督',
            '效果跟踪分析'
          ]
        },
        {
          id: 4,
          title: '心理健康管理',
          icon: '🧘‍♀️',
          description: '关注心理健康，提供心理评估和疏导服务，维护身心平衡。',
          features: [
            '心理状态评估',
            '压力管理指导',
            '情绪调节训练',
            '心理咨询疏导'
          ]
        },
        {
          id: 5,
          title: '慢病管理',
          icon: '💊',
          description: '针对慢性疾病患者，提供系统化的健康管理服务，控制病情发展。',
          features: [
            '病情监测评估',
            '治疗方案优化',
            '生活方式指导',
            '并发症预防'
          ]
        },
        {
          id: 6,
          title: '抗衰老管理',
          icon: '⏳',
          description: '运用先进技术延缓衰老过程，保持年轻活力和健康状态。',
          features: [
            '衰老程度评估',
            '抗衰老方案制定',
            '细胞修复调理',
            '生活方式优化'
          ]
        },
        {
          id: 7,
          title: '基础套餐',
          icon: '⏳',
          description: '适合亚健康人群的基础健康管理服务',
          features: [
            '量子健康检测',
            '健康评估报告',
            '基础营养指导',
            '运动方案制定',
            '专家一对一咨询',
            '24小时健康咨询'
          ]
        },
        {
          id: 8,
          title: '标准套餐',
          icon: '⏳',
          description: '适合慢性病患者的标准健康管理服务',
          features: [
            '量子健康检测',
            '健康评估报告',
            '基础营养指导',
            '运动方案制定',
            '专家一对一咨询',
            '24小时健康咨询'
          ]
        },
        {
          id: 9,
          title: '尊享套餐',
          icon: '⏳',
          description: '适合高端人群的全方位健康管理服务',
          features: [
            '量子健康检测',
            '健康评估报告',
            '基础营养指导',
            '运动方案制定',
            '专家一对一咨询',
            '24小时健康咨询'
          ]
        }
      ],
      processSteps: [
        {
          id: 1,
          title: '健康评估',
          description: '通过量子检测技术和传统体检相结合，全面了解您的健康状况，识别潜在风险。',
          duration: '1-2天',
          method: '量子检测 + 体检'
        },
        {
          id: 2,
          title: '方案制定',
          description: '专家团队根据评估结果，制定个性化的健康管理方案，包括营养、运动、心理等方面。',
          duration: '3-5天',
          method: '多学科会诊'
        },
        {
          id: 3,
          title: '实施执行',
          description: '在专业指导下执行健康管理方案，定期跟踪效果，及时调整优化。',
          duration: '持续进行',
          method: '专业指导 + 自我管理'
        },
        {
          id: 4,
          title: '效果评估',
          description: '定期进行健康评估，分析管理效果，调整后续方案，确保达到最佳健康目标。',
          duration: '每月评估',
          method: '效果跟踪 + 方案调整'
        }
      ],
      targetAudience: [
        {
          id: 1,
          title: '亚健康人群',
          icon: '😴',
          description: '长期疲劳、睡眠质量差、注意力不集中等亚健康状态的人群。',
          symptoms: ['疲劳乏力', '睡眠障碍', '记忆力下降', '免疫力低下']
        },
        {
          id: 2,
          title: '慢性病患者',
          icon: '🏥',
          description: '高血压、糖尿病、心脏病等慢性疾病需要长期管理的人群。',
          symptoms: ['血糖异常', '血压不稳', '心血管问题', '代谢紊乱']
        },
        {
          id: 3,
          title: '中老年人群',
          icon: '👴',
          description: '关注健康长寿，希望延缓衰老、提升生活质量的中老年朋友。',
          symptoms: ['衰老加速', '机能下降', '慢性疼痛', '活力不足']
        },
        {
          id: 4,
          title: '高压人群',
          icon: '💼',
          description: '工作压力大、生活节奏快的职场人士和企业家。',
          symptoms: ['压力过大', '焦虑紧张', '作息紊乱', '健康透支']
        }
      ],
      techAdvantages: [
        {
          id: 1,
          icon: '⚡',
          title: '量子检测技术',
          description: '采用先进的量子共振检测技术，能够深入细胞层面，精准检测身体各系统的功能状态，早期发现潜在健康问题。'
        },
        {
          id: 2,
          icon: '🤖',
          title: 'AI智能分析',
          description: '结合人工智能和大数据分析，对检测结果进行深度分析，提供科学的健康评估和风险预测。'
        },
        {
          id: 3,
          icon: '🎯',
          title: '个性化定制',
          description: '根据每个人的体质特点和健康需求，量身定制健康管理方案，确保方案的针对性和有效性。'
        },
        {
          id: 4,
          icon: '📊',
          title: '全程跟踪管理',
          description: '建立健康档案，全程跟踪管理效果，及时调整方案，确保达到最佳的健康改善效果。'
        }
      ],
      successCases: [
        {
          id: 1,
          name: '李先生',
          title: '企业高管',
          avatar: '👨‍💼',
          content: '长期工作压力大，导致严重亚健康状态。通过3个月的健康管理，疲劳感明显改善，工作效率提升50%。',
          results: [
            { label: '精力水平', value: '提升60%' },
            { label: '睡眠质量', value: '改善80%' },
            { label: '工作效率', value: '提升50%' }
          ]
        },
        {
          id: 2,
          name: '王女士',
          title: '教师',
          avatar: '👩‍🏫',
          content: '更年期综合征困扰多年，通过个性化健康管理，症状得到显著改善，生活质量大幅提升。',
          results: [
            { label: '症状缓解', value: '85%' },
            { label: '情绪稳定', value: '提升70%' },
            { label: '生活质量', value: '提升65%' }
          ]
        },
        {
          id: 3,
          name: '张先生',
          title: '退休干部',
          avatar: '👴',
          content: '高血压、糖尿病等多种慢性病，通过综合健康管理，各项指标得到有效控制。',
          results: [
            { label: '血压控制', value: '稳定达标' },
            { label: '血糖控制', value: '改善40%' },
            { label: '并发症风险', value: '降低60%' }
          ]
        }
      ],
      packages: [
        {
          id: 1,
          name: '基础套餐',
          price: 2980,
          period: '/月',
          description: '适合亚健康人群的基础健康管理服务',
          features: [
            { text: '量子健康检测', included: true },
            { text: '健康评估报告', included: true },
            { text: '基础营养指导', included: true },
            { text: '运动方案制定', included: true },
            { text: '专家一对一咨询', included: false },
            { text: '24小时健康咨询', included: false }
          ],
          featured: false
        },
        {
          id: 2,
          name: '标准套餐',
          price: 5980,
          period: '/月',
          description: '适合慢性病患者的标准健康管理服务',
          features: [
            { text: '量子健康检测', included: true },
            { text: '健康评估报告', included: true },
            { text: '个性化营养指导', included: true },
            { text: '专业运动指导', included: true },
            { text: '专家一对一咨询', included: true },
            { text: '24小时健康咨询', included: false }
          ],
          featured: true
        },
        {
          id: 3,
          name: '尊享套餐',
          price: 9980,
          period: '/月',
          description: '适合高端人群的全方位健康管理服务',
          features: [
            { text: '量子健康检测', included: true },
            { text: '深度健康评估', included: true },
            { text: '全方位营养指导', included: true },
            { text: '私人运动教练', included: true },
            { text: '专家团队服务', included: true },
            { text: '24小时健康咨询', included: true }
          ],
          featured: false
        }
      ],
      faqs: [
        {
          id: 1,
          question: '量子健康检测安全吗？',
          answer: '量子健康检测是一种完全无创的检测技术，不使用任何辐射或药物，对人体没有任何伤害，检测过程安全舒适。',
          open: false
        },
        {
          id: 2,
          question: '健康管理需要多长时间才能看到效果？',
          answer: '效果因人而异，一般来说，亚健康问题在1-2个月内就能感受到明显改善，慢性病管理需要3-6个月的持续调理才能达到理想效果。',
          open: false
        },
        {
          id: 3,
          question: '健康管理服务包含哪些内容？',
          answer: '包括量子健康检测、个性化方案制定、营养指导、运动管理、心理疏导、慢病管理等多个方面，根据个人需求定制服务内容。',
          open: false
        },
        {
          id: 4,
          question: '如何选择适合自己的服务套餐？',
          answer: '我们会根据您的健康状况、管理目标和预算，为您推荐最适合的套餐。您也可以先进行健康评估，再决定选择哪个套餐。',
          open: false
        }
      ],
      bookingForm: {
        name: '',
        phone: '',
        email: '',
        service: '',
        message: ''
      },
      phone: '',
      login: false
    }
  },
  methods: {
    handleFeedBack() {
      this.$message.info('结果反馈功能')
    },
    handleReservationConditioning() {
      this.$message.info('查看预约功能')
    },
    reservationPromptClick() {
      this.$message.info('预约状态查询功能')
    },
    showPdf() {
      this.$message.info('检测结果功能')
    },
    showServiceDetail(service) {
      // 跳转到服务详情页面
      this.$router.push({
        path: '/health-service-detail',
        query: { id: service.id, title: service.title }
      })
    },
    selectPackage(pkg) {
      // 选择套餐并滚动到预约表单
      console.log('选择套餐:', pkg)
      
      // 预填充表单
      this.bookingForm.service = pkg.name
      
      // 滚动到预约表单
      const bookingSection = document.querySelector('.booking-section')
      if (bookingSection) {
        bookingSection.scrollIntoView({ behavior: 'smooth' })
      }
    },
    submitBooking() {
      // 表单验证
      // if (!this.bookingForm.name || !this.bookingForm.phone) {
      //   this.$message?.error('请填写必要的联系信息')
      //   return
      // }
      
      // // 提交预约
      // console.log('提交预约:', this.bookingForm)
      // alert('预约成功！我们的专家将尽快与您联系。')
      
      // // 重置表单
      // this.bookingForm = {
      //   name: '',
      //   phone: '',
      //   email: '',
      //   service: '',
      //   message: ''
      // }
    },
    toggleFaq(faq) {
      // 切换FAQ展开状态
      faq.open = !faq.open
    }
  }
}
</script>

<style  lang="scss" scoped>
/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.logo img {
  height: 40px;
  margin-right: 8px;
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-left: auto;
}

.user-actions .login-btn {
  margin-left: auto;
}

.nav-btn {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3498db;
  }
}

.login-btn {
  background-color: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  
  &:hover {
    background-color: #2980b9;
    color: white;
  }
}

/* 通用容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 页面标题 */
.page-header {
  background: linear-gradient(135deg, #1890FF, #40a9ff);
  color: white;
  padding: 4rem 0;
  text-align: center;
}

.page-header h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.page-header p {
  font-size: 1.2rem;
  opacity: 0.9;
}

/* 服务概览 */
.service-overview {
  padding: 5rem 0;
  background: #f8f9fa;
}

.overview-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.overview-text h2 {
  color: #1890FF;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
}

.overview-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 2rem;
}

.overview-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.feature-icon {
  font-size: 1.5rem;
}

.overview-image {
  height: 400px;
  background: linear-gradient(45deg, #1890FF, #40a9ff);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(24, 144, 255, 0.2);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

/* 服务项目 */
.service-items {
  padding: 5rem 0;
}

.service-items h2 {
  text-align: center;
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

.service-card {
  background: white;
  padding: 2.5rem;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  text-align: center;
  transition: transform 0.3s;
}

.service-card:hover {
  transform: translateY(-10px);
}

.service-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
}

.service-card h3 {
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.service-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.service-features {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.service-features li {
  padding: 0.5rem 0;
  color: #555;
  position: relative;
  padding-left: 1.5rem;
}

.service-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #1890FF;
  font-weight: bold;
}

.btn-detail {
  background: #1890FF;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-detail:hover {
  background: #40a9ff;
  transform: translateY(-2px);
}

/* 服务流程 */
.service-process {
  padding: 5rem 0;
  background: #f8f9fa;
}

.service-process h2 {
  text-align: center;
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.process-timeline {
  display: grid;
  gap: 2rem;
}

.process-step {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.step-number {
  width: 60px;
  height: 60px;
  background: #1890FF;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
}

.step-content h3 {
  color: #1890FF;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.step-details {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.step-duration, .step-method {
  background: #e6f7ff;
  color: #1890FF;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

/* 适用人群 */
.target-audience {
  padding: 5rem 0;
}

.target-audience h2 {
  text-align: center;
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.audience-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.audience-card {
  background: white;
  padding: 2.5rem;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  text-align: center;
}

.audience-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
}

.audience-card h3 {
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.audience-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.audience-symptoms {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

.symptom-tag {
  background: #f0f0f0;
  color: #666;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

/* 技术优势 */
.tech-advantages {
  padding: 5rem 0;
  background: #f8f9fa;
}

.tech-advantages h2 {
  text-align: center;
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.advantages-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 4rem;
  align-items: center;
}

.advantages-list {
  display: grid;
  gap: 2rem;
}

.advantage-item {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
}

.advantage-icon {
  font-size: 2.5rem;
  flex-shrink: 0;
}

.advantage-content h3 {
  color: #1890FF;
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
}

.advantage-content p {
  color: #666;
  line-height: 1.6;
}

.advantages-image {
  height: 300px;
  background: linear-gradient(45deg, #1890FF, #40a9ff);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 6rem;
  box-shadow: 0 10px 30px rgba(24, 144, 255, 0.2);
}

/* 成功案例 */
.success-cases {
  padding: 5rem 0;
}

.success-cases h2 {
  text-align: center;
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.cases-slider {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

.case-item {
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
}

.case-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.case-avatar {
  width: 60px;
  height: 60px;
  background: #f0f0f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
}

.case-info h4 {
  color: #333;
  margin-bottom: 0.3rem;
}

.case-info p {
  color: #666;
  font-size: 0.9rem;
}

.case-content p {
  color: #555;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.case-results {
  display: grid;
  gap: 0.5rem;
}

.result-item {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.result-label {
  color: #666;
}

.result-value {
  color: #1890FF;
  font-weight: bold;
}

/* 服务套餐 */
.service-packages {
  padding: 5rem 0;
  background: #f8f9fa;
}

.service-packages h2 {
  text-align: center;
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.package-card {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  transition: transform 0.3s;
}

.package-card.featured {
  transform: scale(1.05);
  box-shadow: 0 10px 40px rgba(24, 144, 255, 0.3);
}

.package-card:hover {
  transform: translateY(-5px);
}

.package-card.featured:hover {
  transform: scale(1.05) translateY(-5px);
}

.package-header {
  background: #1890FF;
  color: white;
  padding: 2rem;
  text-align: center;
}

.package-card.featured .package-header {
  background: linear-gradient(135deg, #1890FF, #40a9ff);
}

.package-header h3 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
}

.package-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.5rem;
}

.price {
  font-size: 3rem;
  font-weight: bold;
}

.period {
  font-size: 1rem;
  opacity: 0.8;
}

.package-content {
  padding: 2rem;
}

.package-description {
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
}

.package-features {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.package-features li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.package-features li.included {
  color: #333;
}

.package-features li:not(.included) {
  color: #999;
}

.check-icon {
  font-weight: bold;
}

.package-features li.included .check-icon {
  color: #52c41a;
}

.btn-select {
  width: 100%;
  background: #1890FF;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 1rem;
}

.btn-select.featured {
  background: linear-gradient(135deg, #1890FF, #40a9ff);
}

.btn-select:hover {
  background: #40a9ff;
}

/* 预约表单 */
.booking-section {
  padding: 5rem 0;
}

.booking-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
}

.booking-info h2 {
  color: #1890FF;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
}

.booking-info p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 2rem;
}

.booking-features {
  display: grid;
  gap: 1rem;
}

.booking-feature {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.booking-feature .icon {
  font-size: 1.5rem;
}

.booking-form {
  background: white;
  padding: 2.5rem;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.booking-form h3 {
  color: #333;
  font-size: 1.8rem;
  margin-bottom: 2rem;
  text-align: center;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s, box-shadow 0.3s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1890FF;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.btn-submit {
  width: 100%;
  background: #1890FF;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 1rem;
  font-weight: 500;
}

.btn-submit:hover {
  background: #40a9ff;
  transform: translateY(-2px);
}

/* 常见问题 */
.faq-section {
  padding: 5rem 0;
  background: #f8f9fa;
}

.faq-section h2 {
  text-align: center;
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: white;
  margin-bottom: 1rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  cursor: pointer;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
}

.faq-question h3 {
  color: #333;
  font-size: 1.2rem;
  margin: 0;
}

.faq-toggle {
  font-size: 1.5rem;
  color: #1890FF;
  font-weight: bold;
}

.faq-answer {
  padding: 0 1.5rem 1.5rem;
  border-top: 1px solid #f0f0f0;
}

.faq-answer p {
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* 底部样式 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}


/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-links {
    display: none;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .overview-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .overview-features {
    grid-template-columns: 1fr;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }

  .process-step {
    flex-direction: column;
    text-align: center;
  }

  .advantages-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .booking-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .packages-grid {
    grid-template-columns: 1fr;
  }

  .package-card.featured {
    transform: none;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>